import React from 'react';
import { Container } from 'react-bootstrap';
import Tabs from '../../components/TabComp/Tabs';
import Tab from '../../components/TabComp/Tab';
import BannerImage from '../../assets/JobBoard_Banner.png';
import TitleImage from '../../assets/SignUp_Title.png';
import  Company  from './company'
import Veteran from './veteran'
import './index.css';
import styled from 'styled-components';

import 'react-toastify/dist/ReactToastify.css';

const Banner = styled.div`
    background-image: url(${BannerImage});
    min-height: 400px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    @media screen and (max-width: 450px) {
        min-height: 225px;
    }
`;
const Title = styled.div`
    background-image: url(${TitleImage});
    min-height: 139px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    width: 65%;    
    margin: auto;
    @media screen and (max-width: 450px) {
        min-height: 60px;
    }
`;
function SignUp() {
    let companyRef;
    let veteranRef;
    return (
        <>
        <Banner/>
        <Title/>
        <div className='title'>Thank you for participating in our veteran job fair. Please create an account in order to get started.</div>
        <div className='signup-container'>
            <Container>
                <Tabs defaultActiveKey="profile" id="uncontrolled-tab-example" className="mb-3">
                    {/* <Tab header={'Company'} content={<Company ref={ins => { companyRef = ins}}/>} /> */}
                    <Tab header={"Veteran Signup"} content={<Veteran ref={ins => { veteranRef = ins}}/>} />
                </Tabs>
                <button className='btnClass' onClick={() => {
                   companyRef?.companyForm[5].click();
                   veteranRef?.veteranForm[4].click();
                }}>Get Started Now</button>
            </Container>
        </div>
        </>
    )
}

export default SignUp

